export default __webpack_public_path__ + "static/media/climbing.6f843e28.jpg";